"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var icons_1 = require("@ant-design/icons");
var antd_1 = require("antd");
var index_modules_css_1 = __importDefault(require("portal/index.modules.css"));
var react_1 = __importStar(require("react"));
var firestore_1 = require("react-firebase-hooks/firestore");
var react_i18next_1 = require("react-i18next");
var react_signature_canvas_1 = __importDefault(require("react-signature-canvas"));
var app_1 = __importStar(require("firebase/app"));
var uuid_1 = require("uuid");
var collectionsRef_1 = require("common/db/collectionsRef");
function SignatureTab() {
    var _this = this;
    var _a, _b;
    var _c = (0, react_1.useState)(""), trimmedDataURL = _c[0], setTrimmedDataURL = _c[1];
    var _d = (0, react_1.useState)({}), sigPad = _d[0], setSigPad = _d[1];
    var _e = (0, react_1.useState)([]), fileList = _e[0], setFileList = _e[1];
    var _f = (0, react_1.useState)(false), saveButton = _f[0], setSaveButton = _f[1];
    var uid = (_a = (0, app_1.auth)().currentUser) === null || _a === void 0 ? void 0 : _a.uid;
    var t = (0, react_i18next_1.useTranslation)().t;
    var storage = app_1.default.storage().ref("signatures").child(uid).child("".concat((0, uuid_1.v4)(), "-signature"));
    var _g = (0, firestore_1.useDocument)(collectionsRef_1.usersRef.doc(uid !== null && uid !== void 0 ? uid : 'loadingUser')), userSnapshot = _g[0], loading = _g[1];
    if (loading) {
        return (0, jsx_runtime_1.jsx)(antd_1.Spin, {});
    }
    var userData = userSnapshot === null || userSnapshot === void 0 ? void 0 : userSnapshot.data();
    var onTirm = function () {
        setTrimmedDataURL(sigPad === null || sigPad === void 0 ? void 0 : sigPad.getTrimmedCanvas().toDataURL("image/png"));
        setSaveButton(true);
    };
    var onSave = function () { return __awaiter(_this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            storage.putString(trimmedDataURL, "data_url").then(function (d) { return __awaiter(_this, void 0, void 0, function () {
                var downloadURL;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, d.ref.getDownloadURL()];
                        case 1:
                            downloadURL = _a.sent();
                            return [4 /*yield*/, collectionsRef_1.usersRef.doc(uid).update({
                                    signatureURL: downloadURL
                                }).then(function () { return antd_1.message.success("Your signature has been saved well!"); })];
                        case 2:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); });
            return [2 /*return*/];
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ style: { height: "100vh" } }, { children: [(0, jsx_runtime_1.jsxs)(antd_1.Col, __assign({ span: 10 }, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("b", { children: "You can design your signature (removed background) by visit" }), "  ", (0, jsx_runtime_1.jsx)("a", __assign({ href: "https://www.remove.bg/upload" }, { children: "here" }))] }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("b", { children: "Then Upload your removed background signature by" }), " ", (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(antd_1.Upload, __assign({ data: function (data) {
                                            console.log(data);
                                            storage.put(data).then(function (d) { return __awaiter(_this, void 0, void 0, function () {
                                                var downloadURL;
                                                return __generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0: return [4 /*yield*/, d.ref.getDownloadURL()];
                                                        case 1:
                                                            downloadURL = _a.sent();
                                                            return [4 /*yield*/, collectionsRef_1.usersRef.doc(uid).update({
                                                                    signatureURL: downloadURL
                                                                }).then(function () { return antd_1.message.success("Your signature has been saved well!"); })];
                                                        case 2:
                                                            _a.sent();
                                                            return [2 /*return*/];
                                                    }
                                                });
                                            }); });
                                        }, listType: "picture-card", defaultFileList: [{ url: userData.signatureURL, status: "done", name: "signature" }], className: "upload-list-inline" }, { children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(icons_1.PlusOutlined, {}), (0, jsx_runtime_1.jsx)("div", __assign({ style: { marginTop: 8 } }, { children: "Upload" }))] }) })), (0, jsx_runtime_1.jsx)("br", {})] })] })] })), (0, jsx_runtime_1.jsx)(antd_1.Col, __assign({ span: 30 }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: index_modules_css_1.default.containerSig }, { children: [(0, jsx_runtime_1.jsx)("b", { children: "You can draw you signature using the pad below:" }), (0, jsx_runtime_1.jsx)("div", __assign({ className: index_modules_css_1.default.sigContainer }, { children: (0, jsx_runtime_1.jsx)(react_signature_canvas_1.default, { canvasProps: { className: index_modules_css_1.default.sigPad }, ref: function (ref) { return setSigPad(ref); } }) })), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ className: index_modules_css_1.default.buttons, onClick: function () {
                                        sigPad.clear();
                                        setSaveButton(false);
                                        setTrimmedDataURL("");
                                    } }, { children: "Clear" })), (0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ className: index_modules_css_1.default.buttons, onClick: onTirm }, { children: "Trim" })), saveButton ? (0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ danger: true, type: "primary", className: index_modules_css_1.default.buttons, onClick: onSave }, { children: "Save" })) : null] }), (0, jsx_runtime_1.jsxs)("div", __assign({ style: { margin: "2%" } }, { children: [trimmedDataURL
                                    ? (0, jsx_runtime_1.jsx)("img", { className: index_modules_css_1.default.sigImage, src: trimmedDataURL })
                                    : null, (0, jsx_runtime_1.jsx)("img", { className: index_modules_css_1.default.sigImage, src: (_b = userData === null || userData === void 0 ? void 0 : userData.signatureURL) !== null && _b !== void 0 ? _b : "" })] }))] })) }))] })));
}
exports.default = SignatureTab;
